import React from 'react';

const Icon = () => {
    return (
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.76378 1.10007L1.84242 5.43492C1.13456 5.81638 1.13456 6.85674 1.84242 7.23821L9.49413 11.365C9.7975 11.5384 10.1346 11.5037 10.4379 11.365L18.157 7.13418C18.8649 6.75271 18.8649 5.74702 18.157 5.33087L10.7076 1.13474C10.4379 0.961344 10.0672 0.961352 9.76378 1.10007Z" stroke="#737FA4" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M1 11.1567L9.56179 15.7343C9.79775 15.873 10.1011 15.873 10.3708 15.7343L19 11.4342" stroke="#737FA4" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M1 15.3184L9.56179 19.896C9.79775 20.0347 10.1011 20.0347 10.3708 19.896L19 15.5958" stroke="#737FA4" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default Icon;


